import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import Layout from '../components/layout';
import styles from '../styles/pricing.module.scss';
import { useState } from 'react';
import Link from 'next/link';
import { prices } from '../constants/configuration';
import Image from 'next/image';

export default function Pricing() {
  const router = useRouter();
  const { t } = useTranslation('pricing');

  const options = [1, 2, 3];
  const [hardware, setHardware] = useState({
    cpu: options[0],
    ram: options[0],
    storage: options[0],
    gpu: options[0]
  });

  const price = hardware.cpu * 1.25 + hardware.ram * 0.0625 + hardware.storage * 0.0075 + hardware.gpu * 2.5;

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
        <section className={styles.pricing_main}>
        <div className={styles.waves}>
          <Image src='/waves.webp' alt='Waves' unoptimized layout='fill' objectFit='none' objectPosition="left top" />
        </div>
            <div className={styles.content}>
              <h1>{t('pricingTitle')}</h1>
          <p>{t('pricingDescription')}</p>
              <Link href='/configuration'>
                <a><button className='btn cloud'>{t('button')}</button></a>
              </Link>
            </div>
        </section>
        <section className={styles.how_it_work}>
          <h2>{t('subscription')}</h2>
          <ul>
            <li>{t('support')}</li>
            <li>{t('maintenance')}</li>
            <li>{t('right_support')}</li>
          </ul>
          <h2>{t('right_support')}</h2>
          <div className={styles['support-table']}>
            <table>
              <thead>
                <tr>
                  <th><b>{t('type')}</b></th>
                  <th>{t('basic')}</th>
                  <th>{t('standart')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>{t('request')}</th>
                  <th>{t('medium_basic')}</th>
                  <th>{t('medium_standard')}</th>
                </tr>
                <tr className={styles.blue}>
                  <th>{t('hight_request')}</th>
                  <th>{t('hight_basic')}</th>
                  <th>{t('hight_standard')}</th>
                </tr>
                <tr>
                  <th>{t('critical_request')}</th>
                  <th>{t('critical_basic')}</th>
                  <th>{t('critical_standard')}</th>
                </tr>
              </tbody>
            </table>
          </div>
          <p className='small-font'>{t('subscription_description')}</p>
          <h2>{t('price_title')}</h2>
          <div className={styles['price-table']}>
            <table>
              <thead>
                <tr>
                  <th><b>{t('type')}</b></th>
                  <th>{t('basic')}</th>
                  <th>{t('standart')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>{t('periodicity')}</th>
                  <th>{t('monthly')}</th>
                  <th>{t('monthly')}</th>
                </tr>
                <tr className={styles.blue}>
                  <th>{t('support_level')}</th>
                  <th>{t('support_level_basic')}</th>
                  <th>{t('support_level_standard')}</th>
                </tr>
                <tr>
                  <th>{t('price')}</th>
                  <th>
                    <nobr>{t('vCPU')}</nobr>...${prices.basic.cpu}<br /><br />
                    <nobr>{t('ram')}</nobr>...${prices.basic.ram}<br /><br />
                    <nobr>{t('storage')}</nobr>...${prices.basic.storage}<br /><br />
                    <nobr>{t('gpu')}</nobr>...${prices.basic.gpu}
                  </th>
                  <th>
                    <nobr>{t('vCPU')}</nobr>...${prices.standart.cpu}<br /><br />
                    <nobr>{t('ram')}</nobr>...${prices.standart.ram}<br /><br />
                    <nobr>{t('storage')}</nobr>...${prices.standart.storage}<br /><br />
                    <nobr>{t('gpu')}</nobr>...${prices.standart.gpu}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
          {/* <h2 className={styles.details}>{t('server_derails')}</h2> */}
          {/* <div className={styles.hardware}>
            <div>
              <label>
                {t('vCPU')}
                <select value={hardware.cpu} onChange={(e) => setHardware(prevState => ({ ...prevState, cpu: e.target.value }))}>
                  { options.map(value => <option key={value} value={value}>{value}</option>) }
                </select>
              </label>
              <label>
                {t('ram')}
                <select value={hardware.ram} onChange={(e) => setHardware(prevState => ({ ...prevState, ram: e.target.value }))}>
                  { options.map(value => <option key={value} value={value}>{value}</option>) }
                </select>
              </label>
              <label>
                {t('storage')}
                <select value={hardware.storage} onChange={(e) => setHardware(prevState => ({ ...prevState, storage: e.target.value }))}>
                  { options.map(value => <option key={value} value={value}>{value}</option>) }
                </select>
              </label>
              <label>
                {t('gpu')}
                <select value={hardware.gpu} onChange={(e) => setHardware(prevState => ({ ...prevState, gpu: e.target.value }))}>
                  { options.map(value => <option key={value} value={value}>{value}</option>) }
                </select>
              </label>
            </div>
            <p>{t('price')} {parseFloat(price).toFixed(1)}$</p>
          </div> */}
        </section>
        <section className={styles.configure}>
          <h2>{t('create_future')}</h2>
          <Link href='/configuration'>
            <button className='btn'>{t('button')}</button>
          </Link>
        </section>
    </Layout>
  )
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['pricing', 'common']),
  },
});
